<template lang="pug">
  #signIn.h-100
    appHeader(
      :title="'顧客查詢'"
      :targetRouterName="route"
    )
    router-view.content-body
</template>

<script>
import appHeader from '@/components/partials/AppHeader.vue';
import { SA_ITEMS_LIST_INDEX } from '@/router/sa/items-list';

export default {
  // 不管這邊打大小寫 顯示都會是以大寫形式為主
  name: 'saMemberSearchComponent',
  components: {
    appHeader
  },
  data() {
    return {
      route: SA_ITEMS_LIST_INDEX
    };
  }
};
</script>
